export interface IEmbeddedContent {
	isEnabled: boolean;
	contentLinks: IEmbeddedContentLink[];
}

export interface IEmbeddedContentLink {
	id?: string;
	name: string;
	code: string;
	icon: string;
	isEnabled?: boolean;
	resourceUri?: string;
	isNewEntry?: boolean
}

export enum EmbeddedContentIcon {
	Ballot = 'ballot',
	BarChart = 'barchart',
	Group2 = 'group-2',
	Group3 = 'group-3',
	PersonCheck = 'person-check',
	PersonRecord = 'person-record',
	PersonWave = 'person-wave',
	PollChart = 'poll-chart',
	Psychology = 'psychology',
	Send = 'send',
	SmileFace = 'smile-face',
	VoteBox = 'vote-box'
}

export const EmbeddedContentIconList = [
	EmbeddedContentIcon.Ballot,
	EmbeddedContentIcon.BarChart,
	EmbeddedContentIcon.Group2,
	EmbeddedContentIcon.Group3,
	EmbeddedContentIcon.PersonCheck,
	EmbeddedContentIcon.PersonRecord,
	EmbeddedContentIcon.PersonWave,
	EmbeddedContentIcon.PollChart,
	EmbeddedContentIcon.Psychology,
	EmbeddedContentIcon.Send,
	EmbeddedContentIcon.SmileFace,
	EmbeddedContentIcon.VoteBox
];

export const MAX_EMBEDDED_LINKS = 5;
